export default {
    name: 'article-viewport',
    template: require('../../../../../../templates/article-viewport.pug')
};
